<template>
  <div id="container">
    <div class="item-box-content details-line-height" style="padding-bottom: 0px;">
      <div class="title-font-style">
        <span>备货信息</span>
      </div>
      <el-form class="inner-from">
        <el-row>
          <el-col :span="8">
            <el-form-item label="备货编号：">{{ formContent.stockupCode }}</el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="备货方式：">{{ formContent.stockupType }}</el-form-item>
          </el-col>-->
          <el-col :span="16">
            <el-form-item label="请求备货时间：">{{ formContent.createDate | dateFilter }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="公司名称：">
              <span class="approval" @click="onCusName">{{ formContent.cusName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备货状态：">{{formContent.stockupState|stockupStateFilter}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="预计发货时间：">{{ formContent.deliveryTime | dateFilterD }}</el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formContent.stockupType === '入库备货'">
          <el-col :span="8">
            <el-form-item label="备货仓库：">{{ formContent.storageName }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库地址：">{{ formContent.storageAddress }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">{{ formContent.storagePhone }}</el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="24">
            <el-form-item label="物流费用：">{{ formContent.expressFeeType }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注：">{{ formContent.mark }}</el-form-item>
          </el-col>
          <el-col :span="24" class="line"></el-col>
          <el-col :span="8">
            <el-form-item label="发货设置：">{{ formContent.sendType }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发货人：">{{ formContent.sendPeople }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">{{ formContent.sendPhone }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货人：">{{ formContent.receivePeople }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">{{ formContent.receivePhone }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货地址：">{{ formContent.receiveAddress }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-show="isReleaseRepertory" v-if="formContent.stockupType === '入库备货'">
      <div class="item-box-content">
        <div class="title-font-style">
          <span>释放库存进度</span>
        </div>
      </div>
      <el-steps finish-status="finish" :active="steps" style="margin: auto; width: 60%;">
        <el-step title="发起申请" icon="el-icon-success"></el-step>
        <el-step title="待审核" icon="el-icon-success"></el-step>
        <el-step v-if="ReleaseObj.releaseState===3" :title="auditResult" status="error"></el-step>
        <el-step v-else :title="auditResult" icon="el-icon-success"></el-step>
      </el-steps>
      <div
        class="item-box-content details-line-height"
        style="margin-top: 20px;padding:20px 40px 10px 50px"
      >
        <el-form>
          <el-row>
            <el-col :span="8">
              <el-form-item label="申请人：">{{ ReleaseObj.createUser }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请时间：">{{ ReleaseObj.createDate | dateFilter }}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注：">{{ ReleaseObj.mark }}</el-form-item>
            </el-col>
          </el-row>
          <div v-if="ReleaseObj.releaseState !== 1">
            <el-row>
              <el-col :span="24" class="line"></el-col>
              <el-col :span="8">
                <el-form-item label="审批人：">{{ ReleaseObj.approvalUser }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="审批时间：">{{ReleaseObj.approvalDate | dateFilter}}</el-form-item>
              </el-col>
              <el-col :span="24" v-if="ReleaseObj.releaseState === 3">
                <el-form-item label="拒绝原因：">{{ formContent.message }}</el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </div>
    <div class="item-box-content">
      <el-row style="margin-bottom:20px">
        <el-col :span="12" class="title-font-style">
          <span>备货清单</span>
        </el-col>
        <!-- <el-col :span="12" style="text-align: right;">
          <el-button
            v-if="formContent.stockupType === '入库备货'"
            @click="onReleaseRepertory"
            :disabled="!deliver || !releaseContent"
            type="primary"
            plain
          >释放库存</el-button>
        </el-col> -->
      </el-row>
      <div
        v-if="formContent.stockupType === '入库备货'"
        style="margin:20px"
      >释放库存后，当前产品将重新备货后才可发货，且不产生资金占用成本</div>
      <el-table
        border
        ref="tableRef"
        :data="list"
        max-height="378"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column fixed label="品牌" prop="brandName" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proName" label="产品名称" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onProductDetail(scope.row)"
            >{{ scope.row.proType }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="orderNumber" label="订货号" width="120"></el-table-column>
        <el-table-column prop="cbUnit" label="单位"></el-table-column>
        <el-table-column prop="stockupCount" label="数量"></el-table-column>
        <el-table-column prop="cbExtimeValue" label="货期" width="65">
          <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
        </el-table-column>
        <el-table-column label="销售单价">
          <template slot-scope="scope">{{ scope.row.cbPrice | priceFilter }}</template>
        </el-table-column>
        <el-table-column label="毛利率">
          <template slot-scope="scope">{{ scope.row.cbRate|perCentFilter }}</template>
        </el-table-column>
        <el-table-column label="销售总额" min-width="120">
          <template slot-scope="scope">{{ scope.row.cbTotal | priceFilter }}</template>
        </el-table-column>
        <el-table-column label="实际供货单价" min-width="110">
          <template slot-scope="scope">{{ scope.row.cbUnitPrice | priceFilter }}</template>
        </el-table-column>
        <el-table-column label="实际供货总价" min-width="110">
          <template slot-scope="scope">{{ scope.row.cbUnitTotal | priceFilter }}</template>
        </el-table-column>
        <!-- <el-table-column prop="stockupCount" label="直发数量"></el-table-column>
        <el-table-column prop="stockupCount" label="入库数量"></el-table-column>-->
        <!-- <el-table-column label="配货方式">
          <template slot-scope="scope">{{ scope.row.distributionType===1?'库存':'采购' }}</template>
        </el-table-column>
        <el-table-column label="备货状态">
          <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
        </el-table-column>-->
        <el-table-column label="状态更新时间" min-width="130">
          <template slot-scope="scope">{{ scope.row.updateDate | dateFilter }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="item-box-content" style="height: 230px;" v-show="isReleaseR">
      <div class="title-font-style">
        <span>释放库存</span>
      </div>
      <el-form label-width="85px" style="margin-top: 20px;">
        <el-form-item label="申请原因：">
          <el-input type="textarea" :rows="5" v-model="mark"></el-input>
          <div>如存在已经发货的产品，仍然可以发起申请，发起的释放库存清单中，不包含已发货的产品;</div>
        </el-form-item>
        <el-form-item label-width="20px">
          <el-button @click="onLaunchApplication" type="primary">发起申请</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-------------- 确认释放库存 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="titleRe"
      :content="contentRe"
    ></open-or-close>
    <!-------------- 工单日志 -------------->
    <operation-log-and-flow :flowLabel="flowLabel" :id="id"></operation-log-and-flow>
    <!-------------- 释放库存被拒绝 弹窗 -------------->
    <el-dialog title="释放库存申请被拒绝" :visible.sync="dialogFormVisible" width="30%">
      <div>拒绝原因：{{ formContent.message }}</div>
      <div style="margin-top: 20px;">申请被拒绝后，可再次发起释放库存申请。</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow' // 工单日志
import OpenOrClose from '@/components/OpenOrClose/index'
import { queryByOcsId, orderContractRelease } from '@/api/sell/sellManage'
export default {
  components: {
    'operation-log-and-flow': operationLogAndFlow,
    'open-or-close': OpenOrClose
  },
  data() {
    return {
      mark: '', // 释放库存原因
      loadingTable: false, // 列表loading
      list: [],
      flowLabel: '仓储备货流程', // 日志
      steps: 1, // 进度条状态
      id: 0, //
      titleRe: '确认释放库存',
      contentRe: '确认后将发起审批任务，审批过程中当前产品不允许发货',
      isReleaseRepertory: false, //  控制释放库存进度是否显示
      isReleaseR: false, //  控制释放库存申请 是否显示
      formContent: {}, // 备货信息 详情
      deliver: true, // 判断释放库存按钮是否禁用
      releaseContent: false, // 判断 是否提交过释放库存
      ReleaseObj: {}, // 释放库存返回信息
      dialogFormVisible: false, // 释放库存结果弹窗
      auditResult: '审核通过', // 审核结果
      processStatus: 'success' // 当前步骤的状态
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getList()
  },
  methods: {
    onCusName() {
      this.$router.push({
        name: 'customer/details',
        query: { id: this.formContent.cusId }
      })
    },
    onProductDetail(row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    // 列表数据
    getList() {
      this.loadingTable = true
      queryByOcsId(this.id)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.releaseContent = res.data.obj.releaseContent
            this.deliver = res.data.obj.deliver
            this.formContent = JSON.parse(JSON.stringify(res.data.obj))
            if (this.formContent.orderContractRelease) {
              this.ReleaseObj = this.formContent.orderContractRelease
              this.steps = this.ReleaseObj.releaseState + 1
              if (this.ReleaseObj.releaseState === 3) {
                this.dialogFormVisible = true
                this.steps = 3
                this.isReleaseRepertory = true
                this.auditResult = '审核不通过'
                this.processStatus = 'error '
              } else if (this.ReleaseObj.releaseState === 2) {
                this.isReleaseRepertory = true
              } else if (this.ReleaseObj.releaseState === 1) {
                this.isReleaseRepertory = true
              }
            }
            this.flowLabel =
              this.formContent.stockupType === '入库备货' ? '仓储备货流程' : '直发备货流程'
            this.list = JSON.parse(JSON.stringify(res.data.obj.orderContractStockupContentVoList))
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 释放库存
    onReleaseRepertory() {
      this.isReleaseR = true
      this.isReleaseRepertory = false
    },
    // 释放库存确认
    onUpdataState() {
      const obj = {
        mark: this.mark,
        ocbId: this.formContent.ocbId,
        ocsId: this.id
      }
      orderContractRelease(obj).then((res) => {
        if (res.data.code === 200) {
          this.ReleaseObj = res.data.obj
          this.steps = this.ReleaseObj.releaseState + 1
          this.releaseContent = false
          this.isReleaseRepertory = true
          this.isReleaseR = false
          this.$message.success('已发起释放库存申请,请等待审核!')
        }
      })
    },
    // 发起申请
    onLaunchApplication() {
      if (this.mark) {
        this.$refs.OpenOrCloseRefs.onInitial()
      } else {
        this.$message.error('请填写申请原因')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.line {
  background-color: #f5f7fa;
  height: 2px;
  width: 100%;
  margin-bottom: 20px;
}
</style>
